import React from 'react';
import { Reveal } from './Reveal';
const withoutItems = ['😓 References scattered across dozens of websites and half-finished books', '🔁 Inconsistent sessions with no structured professional foundation', '💭 Searching your phone mid-session for answers you should already have', '😰 Six disciplines studied separately with no system connecting them', '🌑 A practice that feels incomplete and never reaches its full potential'];
const withItems = ['📖 One complete professional library — always at your fingertips', '🎯 Every session backed by a complete, organized reference system', '💪 Confident, professional answers backed by real structured knowledge', '🌙 All 6 disciplines connected in one coherent, integrated framework', '✨ A practice that looks, feels, and performs completely professional'];
type PanelProps = {
  title: string;
  label: string;
  items: string[];
  positive?: boolean;
};
function Panel({
  title,
  label,
  items,
  positive
}: PanelProps) {
  return <div className={`p-7 sm:p-10 ${positive ? 'bg-surface' : 'bg-mist'}`} data-id="element-29" data-mp="1m0gy2ft3m428">
      <p className={`text-xs font-bold uppercase tracking-[0.16em] ${positive ? 'text-sage' : 'text-red-500'}`} data-id="element-30" data-mp="1m2tq5lsklut0">
        {label}
      </p>
      <h3 className="mt-4 font-serif text-3xl leading-tight text-navy" data-id="element-31" data-mp="1d7vu45u4m1xg">{title}</h3>
      <ul className="mt-7 divide-y divide-navy/10" data-id="element-32" data-mp="189kjhsw0bne6">
        {items.map(item => <li key={item} className="py-4 text-sm leading-relaxed text-slate sm:text-base" data-id="element-33" data-mp="1877tqtk0c8qk">
            {item}
          </li>)}
      </ul>
    </div>;
}
export function Comparison() {
  return <section className="w-full bg-mist px-4 py-20 sm:py-24" data-id="element-34" data-mp="20yhst6i8q9us">
      <div className="mx-auto max-w-6xl" data-id="element-35" data-mp="1vy3skamvs47b">
        <Reveal className="mx-auto max-w-3xl text-center" data-id="element-36" data-mp="1vx25t8wi5t9r">
          <h2 className="font-serif text-4xl text-navy sm:text-5xl" data-id="element-37" data-mp="1r0lfq95qt4u1">
            ⚖️ The Difference a <span className="text-sage" data-id="element-38" data-mp="kk9gs5v3jixe">Real System</span> Makes
          </h2>
          <p className="mt-5 text-slate" data-id="element-39" data-mp="fkn2dt3j7wn0">
            You’re not buying files. You’re buying a complete energy healing operating system.
          </p>
        </Reveal>
        <Reveal delay={0.08} data-id="element-40" data-mp="h2lo6928wint">
          <div className="mt-10 overflow-hidden rounded-2xl border border-navy/10 shadow-elevated md:grid md:grid-cols-2" data-id="element-41" data-mp="m0wx8hkpup4z">
            <Panel label="❌ WITHOUT" title="Without Energy Healing System™" items={withoutItems} data-id="element-42" data-mp="81xajfgrkkbg" />
            <Panel positive label="✅ WITH" title="With Energy Healing System™" items={withItems} data-id="element-43" data-mp="czfmzftzpho7" />
          </div>
        </Reveal>
      </div>
    </section>;
}